var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82968 14.9993C6.68028 14.9998 6.53267 14.9668 6.39769 14.9028C6.26271 14.8388 6.14379 14.7453 6.04968 14.6293L1.21968 8.6293C1.07259 8.45037 0.992187 8.22592 0.992187 7.9943C0.992187 7.76267 1.07259 7.53823 1.21968 7.3593L6.21968 1.3593C6.38941 1.15508 6.63333 1.02666 6.89775 1.00228C7.16218 0.977899 7.42546 1.05956 7.62968 1.2293C7.83389 1.39904 7.96232 1.64295 7.9867 1.90738C8.01108 2.1718 7.92941 2.43508 7.75968 2.6393L3.28968 7.9993L7.60967 13.3593C7.73196 13.5061 7.80964 13.6848 7.83351 13.8744C7.85739 14.0639 7.82648 14.2563 7.74442 14.4289C7.66237 14.6014 7.53261 14.7468 7.3705 14.8479C7.20839 14.949 7.02071 15.0015 6.82968 14.9993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.de1c5ee84062f5739ab014e1bbeb39a4.svg";
export { ForwardRef as ReactComponent };